import React, {Component} from 'react';
import PropTypes from 'prop-types';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import appConfig from 'config/app.config';
import Stats from './stats';

class StatsController extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isLoading: true,
			groups: [],
			games: [],
			archivedGames: []
		};
	}

	/**
	 * Component did mount
	 */
	componentDidMount = () => {
		Promise.all([this.getGamesAndGroups(), this.getArchivedGames()]).then(() => {
			this.setState({isLoading: false});
		});
	};

	/**
	 * Get active games and groups
	 * @returns {Promise}
	 */
	getGamesAndGroups = () => {
		const db = firebase.firestore();
		return new Promise((resolve)=> {
			db.collection(appConfig.groupsDbName).get().then((groupDocs) => {
				let groups = [];
				groupDocs.forEach((doc) => {groups.push({...doc.data(), id: doc.id});});

				db.collection(appConfig.gamesDbName).get().then((docs) => {
					let games = [];
					docs.forEach((doc) => {
						const gameObj = {
							...doc.data(), 
							players: groups.filter((g) => {return g.gameId === doc.id;}),
							id: doc.id
						};
						games.push(gameObj);
					});
					this.setState({groups, games}, () => {resolve({status: 'success'});});
				}, (error) => {
					console.error('could not get games: ', error);
					resolve({status: 'error', error: error});
				});
			}).catch((error) => {
				console.error('could not get groups: ', error);
				resolve({status: 'error', error: error});
			});
		});
	};

	/**
	 * Get archived games and groups
	 * @returns {Promise}
	 */
	getArchivedGames = () => {
		const db = firebase.firestore();
		return new Promise((resolve)=> {
			db.collection(appConfig.statsDbName).get().then((docs) => {
				let archivedGames = [];
				docs.forEach((doc) => {archivedGames.push({...doc.data()});});
				this.setState({archivedGames}, () => {resolve({status: 'success'});});
			}, (error) => {
				console.error('could not get archived games: ', error);
				resolve({status: 'error', error: error});
			});
		});
	};


	/**
	 * Render component
	 */
	render = () => {	
		if (this.state.isLoading) return <div>loading ...</div>;
		return (
			<Stats 
				games={this.state.games} 
				archivedGames={this.state.archivedGames} 
				groups={this.state.groups}
				goToPage={this.props.goToPage}
			/>
		);
	};
}

StatsController.propTypes = {
	goToPage: PropTypes.func.isRequired
};

export default StatsController;